import { FillInTheBlanksPinSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { PinBackground } from '../components/PinBackground';

export interface FillInTheBlanksPinProps {
  pinSettings: FillInTheBlanksPinSettings;
  isThumb?: boolean;
  children?: React.ReactNode;
}

export const FillInTheBlanksPinReactComponent: React.FC<FillInTheBlanksPinProps> = ({
  isThumb,
  pinSettings,
  children,
}) => {
  return (
    <FillInTheBlanksWrapper>
      <PinBackground pinType="FILL_IN_THE_BLANKS" settings={pinSettings} isThumb={isThumb} />
      {children}
    </FillInTheBlanksWrapper>
  );
};

const FillInTheBlanksWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;
